import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(() => ({
  button: {
    fontSize: vh(2.08),
    marginLeft: '1vw',
    '&:first-of-type': {
      marginLeft: 0,
    },
  },
}));
